import { UserManager, WebStorageStateStore } from 'oidc-client';
import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { authorizationServerUrl } from '../microservices/authorization_server';


const config = {
  authority: authorizationServerUrl,
  client_id: 'telemetry-portal',
  redirect_uri: 'https://telemetry.blinkelectrics.co.ke/callback',
  response_type: 'code',
  scope: 'openid profile read_profile write_payment read_telemetry offline_access',
  post_logout_redirect_uri: 'https://telemetry.blinkelectrics.co.ke',
  userStore: new WebStorageStateStore({ store: window.localStorage}),
  stateStore: new WebStorageStateStore({store: window.localStorage})
};

const userManager = new UserManager(config);

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() =>{
    if(user){
      setIsAuthenticated(true);
    }
  },[user]);

  const handleCallback = useCallback(async () => {
    try {
      const user = await userManager.signinRedirectCallback();
      setUser(user);
    } catch (error) {
      console.error('Error handling authentication callback:', error);
    }
  }, []);

  const login = useCallback(async () => {
    await userManager.signinRedirect();
  }, []);

  const logout = useCallback(async () => {
    await userManager.signoutRedirect();
    setUser(null);
    setIsAuthenticated(false);
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    if (window.location.pathname === '/callback') {
      handleCallback();
    } else {
      userManager.getUser().then(user => {
        setUser(user);
        setIsAuthenticated(!!user);
      }).catch(error => console.error('Error getting user:', error));
    }
  }, [handleCallback]);

  return (
    <AuthContext.Provider value={{ user, setUser, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};